// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__h0jVP","ant-page-header-heading-title":"styles_ant-page-header-heading-title__DwUsj","table":"styles_table__2Kjyj"};